import { useState } from "react";
import RadioButtonGroup from "./RadioButtonGroup";
import useAxios from "../common/hook/useAxios";
import { toast } from "react-toastify";
import { FaPrint } from "react-icons/fa";
import { AiOutlineFileExcel } from "react-icons/ai";
import { MdPictureAsPdf } from "react-icons/md";
import Modal from "react-modal";
import FilterDropdown from "./FilerDropdown";
import CheckboxButtonGroup from "./CheckboxButtonGroup";
// import { useSearchResults } from "../context/SearchResultsContext";
const FilterHeader = ({
  // handleSearch,
  dataTableRef,
  labsForDropdown,
  orderTypesForDropdown,
  specimentTypesForDropdown,
  // setSelectedValue,
  // setSelectedLab,
  // setSelectedSpecimenType,
  // setSelectedOrderType,
  // selectedValue,
  handleFilter,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLab, setSelectedLab] = useState("");
  const [selectedOrderType, setSelectedOrderType] = useState("");
  const [selectedSpecimenType, setSelectedSpecimenType] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedCheckbox, setSelectedCheckbox] = useState("")
  const { request } = useAxios();
  // const { setResults } = useSearchResults(); // Use the context hook

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const applyFilters = () => {
    handleFilter(
      selectedLab,
      selectedOrderType,
      selectedSpecimenType,
      selectedValue,
      selectedCheckbox
    );
    toggleMenu();
  };
  // Handler functions for each icon
  const handlePrint = () => {
    if (dataTableRef.current) {
      const tableHTML = dataTableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`

        <html>
          <head>
            <title>Intellilab Print</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: left;
              }
            th {
                    background-color: #f4f4f4;
                    font-size:16px;
                  }
                    td{
                    font-size:14px}
                        @media print {
  .hide-on-print {
    display: none !important;
  }
}
            </style>
          </head>
          <body>
            ${tableHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table reference is not set.");
    }
  };

  const handleExcel = () => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Intelli Lab New" };
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/Excel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while fetching labs", {
            autoClose: 3000,
          });
        });
    }
    // Add your logic for Excel export here
  };

  const handlePdf = () => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Intelli Lab New" }; //static
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/PDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while fetching labs", {
            autoClose: 3000,
          });
        });
    }
  };

  return (
    <div className="relative text-black">
      {/* Hamburger Icon */}
      <button
        onClick={toggleMenu}
        className="p-2 bg-white rounded-md mt-auto flex justify-end w-full focus:outline-none"
      >
        <svg
          className="w-6 h-6 text-gray-800 hover:text-gray-600 transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16m-7 6h7"
          />
        </svg>
      </button>
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleMenu}
        className={`absolute flex flex-col min-w-max top-8  p-4 right-0 w-48 bg-white shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
        }`}
        // className="fixed inset-0 flex items-center justify-center overflow-y-auto outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        {/* Radio Button Group */}
        <RadioButtonGroup
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          firstLabel="allPatients"
          secondLabel="requisitions"
        />

        {/* Dropdowns */}
        <div className="p-2">
          <FilterDropdown
            items={labsForDropdown}
            label={"Lab:"}
            setSelectedValue={setSelectedLab}
            selectedValue={selectedLab}
            isHeader={true}
          />
        </div>
        <div className="p-2">
          <FilterDropdown
            items={orderTypesForDropdown}
            label={"Order Type:"}
            setSelectedValue={setSelectedOrderType}
            selectedValue={selectedOrderType}
            isHeader={true}
          />
        </div>
        <div className="p-2">
          <FilterDropdown
            items={specimentTypesForDropdown}
            label={"Specimen Type:"}
            setSelectedValue={setSelectedSpecimenType}
            selectedValue={selectedSpecimenType}
            isHeader={true}
          />
        </div>
        <CheckboxButtonGroup
          selectedCheckbox={selectedCheckbox}
          setSelectedCheckbox={setSelectedCheckbox}
          firstLabel="Encounter"
          secondLabel="POC"
        />
        <button
          onClick={applyFilters}
          className="bg-orange w-1/2 m-auto my-2 text-white px-2 py-2 rounded transition-colors"
        >
          {" "}
          Search
        </button>

        {/* Action Buttons */}
        <div className="flex justify-between p-2 border-t border-gray-200 mt-2">
          <button
            onClick={handlePrint}
            className="text-blue-500 hover:text-blue-700 flex flex-col items-center transition-colors"
            title="Print"
          >
            <FaPrint size={24} />
            Print
          </button>
          <button
            onClick={handleExcel}
            className="text-green-500 hover:text-green-700 flex flex-col items-center transition-colors"
            title="Export to Excel"
          >
            <AiOutlineFileExcel size={24} />
            Export as Excel
          </button>
          <button
            onClick={handlePdf}
            className="text-red-500 hover:text-red-700 flex flex-col items-center transition-colors"
            title="Export to PDF"
          >
            <MdPictureAsPdf size={24} />
            Export as PDF
          </button>
        </div>
      </Modal>
    </div>
  );
};
export default FilterHeader;
